import { mutatorAction } from 'satcheljs';
import getStore from '../store/store';
import type ViewType from '../store/schema/ViewType';
import getAppropriateReadingPaneViewType from '../utils/getAppropriateReadingPaneViewType';

const setMailOrganizationViewTypesMutator: (
    messageListExpansionType: ViewType,
    readingPaneViewType: ViewType
) => void = mutatorAction(
    'setMailOrganizationViewTypes',
    (messageListExpansionType: ViewType, readingPaneViewType: ViewType): void => {
        const store = getStore();
        const currentReadingPaneViewType = store.readingPaneViewType;

        if (messageListExpansionType != 3) {
            store.messageListExpansionType = messageListExpansionType;
        }

        // When switching to group by branches in the quick settings it only updates the ML type
        // so we need to revalidate the current reading pane type when the new list type may make
        // that combination unsupported (eg. switching from conversation mode to conversation with branches,
        // the reading pane type of conversation is no longer supported and needs to be updated to Item).
        if (
            readingPaneViewType != 3 ||
            (messageListExpansionType != 3 && currentReadingPaneViewType != 3)
        ) {
            store.readingPaneViewType = getAppropriateReadingPaneViewType(
                store.messageListExpansionType,
                readingPaneViewType != 3 ? readingPaneViewType : currentReadingPaneViewType
            );
        }
    }
);
export default setMailOrganizationViewTypesMutator;
